import { render, staticRenderFns } from "./GoogleButton.vue?vue&type=template&id=0191d324"
import script from "./GoogleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports